import React, { useEffect } from 'react';
import {Alert, Button} from "shards-react";
import PropTypes from "prop-types";

function UnloadPageConfirm({confirmAlert, setConfirmAlert}) {

  const cancelConfirmAlert = () => {
    confirmAlert.onCancel && confirmAlert.onCancel();
    setConfirmAlert({
      ...confirmAlert,
      visible: false
    })
  }

  if (confirmAlert.visible)
    return (
      <Alert theme="light"
             className="primary-alert text-bold fixed-top offset-md-3 offset-lg-2 mb-0 alert alert-danger text-unload-page-confirm fade show">
        {confirmAlert.confirmMsg}
        <Button className="mx-2 py-2 btn-normal" size="sm"
                theme="primary" onClick={e => {
          confirmAlert.onConfirm();
          setConfirmAlert({
            ...confirmAlert,
            visible:false
          })
        }
        }>Yes</Button>
        <Button className="mx-2 py-2" size="sm"
                theme="white" onClick={cancelConfirmAlert}>Cancel</Button>
      </Alert>
    )

  return null;
}

UnloadPageConfirm.propTypes = {
  confirmAlert: PropTypes.object.isRequired,
  setConfirmAlert: PropTypes.func.isRequired,
}

export default UnloadPageConfirm;
